export const AssetStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
  Retired: 'Retired',
  Disposed: 'Disposed',
  Faulty: 'Faulty',
  Returned: 'Returned',
  Lost: 'Lost',
} as const;
export type AssetStatus = (typeof AssetStatus)[keyof typeof AssetStatus];
